import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useAsyncFn } from 'react-use';
import { isSingleOfferProductWithOffer } from '@uno/common-cms';
import { useSiteConfig, useSnackAsyncError } from 'libs/common/hooks';
import { getAffiliationProducts } from 'services/networking/affiliation';
import { AffiliationCta, ErrorIcon } from './AffiliationBlockCta.style';

var AffiliationBlockCta = function AffiliationBlockCta(_ref) {
  var _entityData$title;

  var entityData = _ref.entityData;
  var intl = useIntl();

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id,
      lang = _useSiteConfig.lang;

  var _useSnackAsyncError = useSnackAsyncError(),
      snackAsyncError = _useSnackAsyncError.snackAsyncError;

  var _useState = useState(),
      selectedProduct = _useState[0],
      updateSelectedProduct = _useState[1];

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(affiliationId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return snackAsyncError({
                messageId: 'affiliation.error.get-products',
                callback: function () {
                  var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$getAffiliation, products;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return getAffiliationProducts(lang, affiliationId, site);

                          case 2:
                            _yield$getAffiliation = _context.sent;
                            products = _yield$getAffiliation.products;

                            if (products[0] !== undefined) {
                              updateSelectedProduct(products[0]);
                            }

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function callback() {
                    return _callback.apply(this, arguments);
                  }

                  return callback;
                }()
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      retrieveProductLoading = _useAsyncFn2[0].loading,
      retrieveProduct = _useAsyncFn2[1];

  useEffect(function () {
    if (entityData.affiliationId !== undefined) {
      void retrieveProduct(entityData.affiliationId);
    }
  }, [entityData, retrieveProduct]);
  var affiliationIsBroken = !retrieveProductLoading && !isSingleOfferProductWithOffer(selectedProduct);
  return __jsx(AffiliationCta, {
    isBroken: affiliationIsBroken,
    title: affiliationIsBroken ? intl.formatMessage({
      id: 'affiliation.obsolete'
    }) : ''
  }, affiliationIsBroken && __jsx(ErrorIcon, null), (_entityData$title = entityData.title) !== null && _entityData$title !== void 0 ? _entityData$title : intl.formatMessage({
    id: 'affiliation-block-modal.cta.label'
  }));
};

export default AffiliationBlockCta;